import { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import Dialog from '../../../components/Dialog';
import Text from '../../../components/Text';
import { patientSurveyAPI } from '../../../apis';

const SenderContactPopup = ({ handleClose, responseDetailId }) => {
  const [data, setData] = useState({
    title: '',
    senderName: '',
    phone: '',
    email: '',
    address: '',
  });

  const getPatientSurveyContact = async () => {
    try {
      const params = {
        responseDetailId,
      };
      const { result } = await patientSurveyAPI.getPatientSurveyContact(params);
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPatientSurveyContact();
  }, []);

  return (
    <Dialog
      open={true}
      title="Sender Contact"
      readOnly
      cancel="Close"
      handleCancel={handleClose}
      handleClose={handleClose}
      dialogfootStyle={{ marginTop: '2.5rem' }}
    >
      <Box display="flex" flexDirection="column">
        <Box display="flex">
          <Box width="8rem">
            <Text fontSize="0.875rem" color="#7D86A9">
              Title
            </Text>
            <Text fontSize="1.25rem" color="#2E4469" fontWeight="700">
              {data?.title}
            </Text>
          </Box>
          <Box>
            <Text fontSize="0.875rem" color="#7D86A9">
              Name
            </Text>
            <Text fontSize="1.25rem" color="#2E4469" fontWeight="700">
              {data?.senderName}
            </Text>
          </Box>
        </Box>
        <Box
          display="grid"
          gridTemplateColumns="1fr 1fr"
          borderRadius="0.9375rem"
          bgcolor="#F5FAFF"
          p="1.2rem 1.56rem"
          mt="1.25rem"
          gridGap="1.87rem"
        >
          <Box display="flex" flexDirection="column" gridGap="0.62rem">
            <Text fontSize="1rem" color="#2E4469">
              Telephone No.
            </Text>
            <Text fontSize="1rem" color="#7D86A9">
              {data?.phone}
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.62rem">
            <Text fontSize="1rem" color="#2E4469">
              E-mail
            </Text>
            <Text fontSize="1rem" color="#7D86A9">
              {data?.email ? data?.email : 'N/A'}
            </Text>
          </Box>
          <Box display="flex" flexDirection="column" gridGap="0.62rem">
            <Text fontSize="1rem" color="#2E4469">
              Address
            </Text>
            <Text fontSize="1rem" color="#7D86A9">
              {data?.address ? data?.address : 'N/A'}
            </Text>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SenderContactPopup;
